// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"MySelect_my_select_wrapper__ar7vS","my_select":"MySelect_my_select__ub9Qc","label":"MySelect_label__FrbqR"};